import { ApplicationState } from 'application/redux'
import { close as closeModal, open as openModal } from 'core/modal/redux/actions'
import { connect } from 'react-redux'
import OnnetOffnetComponent from './onnet-offnet-component'
import {
  execute,
  submitChanges
} from './redux/action'

const mapStateToProps = (state: ApplicationState) => ({
  ranges: state.management.onnetOffnet.ranges,
  rangesIpv6: state.management.onnetOffnet.rangesIpv6,
})

export default connect(mapStateToProps, {
  execute,
  openModal,
  closeModal,
  submitChanges
})(OnnetOffnetComponent)
